import { createRef, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EventListener from 'react-event-listener';
import throttle from 'lodash/throttle';
import classNames from 'clsx';
import { setTopBannerHeight } from '../../actions/app';
import css from './top-banner.module.scss';

class TopBanner extends Component {
  static propTypes = {
    className: PropTypes.string,
    setTopBannerHeight: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    contentWrapperStyles: {},
    bannerColor: '',
  };

  constructor(props) {
    super(props);

    this.bannerEl = createRef();
    this.updateDimensions = throttle(this.updateDimensions.bind(this), 0, {
      leading: false,
    });
  }

  componentDidMount() {
    this.updateDimensions();
  }

  updateDimensions() {
    this.props.setTopBannerHeight(this.bannerEl.current.clientHeight);
  }

  render() {
    const { children, className } = this.props;

    return (
      <EventListener target="window" onResize={this.updateDimensions}>
        <div
          className={classNames(css.container, className)}
          ref={this.bannerEl}
        >
          {children}
        </div>
      </EventListener>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setTopBannerHeight: (height) => dispatch(setTopBannerHeight(height)),
  };
}

export default connect(null, mapDispatchToProps)(TopBanner);
